import axios from "axios";

axios.defaults.withCredentials = true;

export default {
  async getDroits() {
    const droits = await axios.get(
      process.env.VUE_APP_BACKEND_API_URL + process.env.VUE_APP_URL_DROIT
    );
    return droits.data;
  },

  async saveDroit(droit) {
    const response = await axios.post(
      process.env.VUE_APP_BACKEND_API_URL + process.env.VUE_APP_URL_DROIT,
      droit
    );
    return response.data;
  },
};
